module.exports = {
  CREATE_ALERT: 'CREATE_ALERT',
  DISMISS_ALERT: 'DISMISS_ALERT',
  DISMISS_LAST_ALERT: 'DISMISS_LAST_ALERT',

  PATIENT: 'PATIENT',
  FETCH_PATIENT_LIST: 'FETCH_PATIENT_LIST',
  FETCH_PATIENT_DETAIL: 'FETCH_PATIENT_DETAIL',
  UPDATE_PATIENT_INFO: 'UPDATE_PATIENT_INFO',
  UPDATE_PATIENT_DATA: 'UPDATE_PATIENT_DATA',
  FETCH_EXPORT_PDF: 'FETCH_EXPORT_P_D_F',

  FILE: 'FILE',
  FETCH_FILE_LIST: 'FETCH_FILE_LIST',
  FETCH_FILE_URL: 'FETCH_FILE_U_R_L',
  DELETE_FILE: 'DELETE_FILE',
  GET_PHOTO_DOWNLOAD_URL: 'GET_PHOTO_DOWNLOAD_U_R_L',

  FETCH_METADATA_PENDING: 'FETCH_METADATA_PENDING',
  FETCH_METADATA_SUCCEEDED: 'FETCH_METADATA_SUCCEEDED',
  FETCH_METADATA_FAILED: 'FETCH_METADATA_FAILED',
  FETCH_METADATA_API_URLS_SUCCEEDED: 'FETCH_METADATA_API_URLS_SUCCEEDED',
  FETCH_METADATA_API_URLS_FAILED: 'FETCH_METADATA_API_URLS_FAILED',
  DELETE_METADATA_SUCCEEDED: 'DELETE_METADATA_SUCCEEDED',
  CREATE_METADATA_SUCCEEDED: 'CREATE_METADATA_SUCCEEDED',
  FETCH_TITLE_BY_ROLE_SUCCEEDED: 'FETCH_TITLE_BY_ROLE_SUCCEEDED',

  METADATA: 'METADATA',
  GET_METADATA: 'GET_METADATA',
  CREATE_METADATA: 'CREATE_METADATA',
  UPDATE_METADATA: 'UPDATE_METADATA',
  DELETE_METADATA: 'DELETE_METADATA',

  USER: 'USER',
  SIGN_UP: 'SIGN_UP',
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DEACTIVATE_USER: 'DEACTIVATE_USER',
  GET_USER_PROFILE: 'GET_USER_PROFILE',
  USER_PROFILE_MODIFIED: 'USER_PROFILE_MODIFIED',
  CHANGE_USER_LANGUAGE: 'CHANGE_USER_LANGUAGE',
  VERIFY_ACCESS_TOKEN: 'VERIFY_ACCESS_TOKEN',
  GET_TEAM_MEMBERS: 'GET_TEAM_MEMBERS',
  QUICK_SIGNUP: 'QUICK_SIGNUP',
  GET_SIGNUP_LIST: 'GET_SIGNUP_LIST',
  APPROVE_SIGNUP: 'APPROVE_SIGNUP',
  DECLINE_SIGNUP: 'DECLINE_SIGNUP',
  GET_CHECKOUT_TOKEN: 'GET_CHECKOUT_TOKEN',
  REQUEST_DEMO: 'REQUEST_DEMO',
  CLEAR_CHECKOUT_TOKEN: 'CLEAR_CHECKOUT_TOKEN',

  CHANGE_USER_TEAM: 'CHANGE_USER_TEAM',
  GET_JOINED_TEAM_LIST: 'GET_JOINED_TEAM_LIST',

  INVITATION: 'INVITATION',
  GET_INVITATION_LIST: 'GET_INVITATION_LIST',
  GET_ASSIGNABLE_ROLES: 'GET_ASSIGNABLE_ROLES',
  SEND_INVITATION: 'SEND_INVITATION',
  RESEND_INVITATION: 'RESEND_INVITATION',

  FETCH_ACTIVITY_LOG_PENDING: 'FETCH_ACTIVITY_LOG_PENDING',
  FETCH_ACTIVITY_LOG_SUCCEEDED: 'FETCH_ACTIVITY_LOG_SUCCEEDED',
  FETCH_ACTIVITY_LOG_FAILED: 'FETCH_ACTIVITY_LOG_FAILED',

  FETCH_TESTIMONIAL_REQUEST: 'FETCH_TESTIMONIAL_REQUEST',
  FETCH_TESTIMONIAL_SUCCESS: 'FETCH_TESTIMONIAL_SUCCESS',
  FETCH_TESTIMONIAL_FAILURE: 'FETCH_TESTIMONIAL_FAILURE',
  DELETE_TESTIMONIAL_SUCCESS: 'DELETE_TESTIMONIAL_SUCCESS',
  UPDATE_TESTIMONIAL_SUCCESS: 'UPDATE_TESTIMONIAL_SUCCESS',
  UPLOAD_TESTIMONIAL_AVATAR_REQUEST: 'UPLOAD_TESTIMONIAL_AVATAR_REQUEST',
  UPLOAD_TESTIMONIAL_AVATAR_SUCCESS: 'UPLOAD_TESTIMONIAL_AVATAR_SUCCESS',
  UPLOAD_TESTIMONIAL_AVATAR_FAILURE: 'UPLOAD_TESTIMONIAL_AVATAR_FAILURE',

  CHANNEL: 'CHANNEL',
  FETCH_CHANNEL: 'FETCH_CHANNEL',
  CREATE_CHANNEL: 'CREATE_CHANNEL',
  ACK_CHANNEL_READ: 'ACK_CHANNEL_READ',
  SET_CURRENT_CHANNEL: 'SET_CURRENT_CHANNEL',
  FETCH_CHANNEL_MEMBERS: 'FETCH_CHANNEL_MEMBERS',
  CREATE_CHANNEL_MEMBERS: 'CREATE_CHANNEL_MEMBERS',
  FETCH_CHANNEL_MSGS: 'FETCH_CHANNEL_MSGS',
  FETCH_PREV_CHANNEL_MSGS: 'FETCH_PREV_CHANNEL_MSGS',
  CREATE_CHANNEL_MESSAGE: 'CREATE_CHANNEL_MESSAGE',
  CONNECT_WEBSOCKET: 'CONNECT_WEBSOCKET',
  DISCONNECT_WEBSOCKET: 'DISCONNECT_WEBSOCKET',
  FETCH_TAGGABLE_MEDICAL_RECORDS: 'FETCH_TAGGABLE_MEDICAL_RECORDS',
  UPLOAD_CHANNEL_AVATAR: 'UPLOAD_CHANNEL_AVATAR',
  UPDATE_CHANNEL: 'UPDATE_CHANNEL',
  DELETE_CHANNEL_MEMBER: 'DELETE_CHANNEL_MEMBER',
  DELETE_CHANNEL: 'DELETE_CHANNEL',
  GET_INVITABLE_USERS: 'GET_INVITABLE_USERS',

  FPP: 'FPP',
  GET_FPP_RECORD_LIST: 'GET_FPP_RECORD_LIST',
  GET_FPP_MAIN_QUESTIONS: 'GET_FPP_MAIN_QUESTIONS',
  GET_FPP_RECOMMENDATION: 'GET_FPP_RECOMMENDATION',
  SUBMIT_FPP_ADDITIONAL_QUESTIONS: 'SUBMIT_FPP_ADDITIONAL_QUESTIONS',
  GET_SUBMITTED_SURVEY_DETAIL: 'GET_SUBMITTED_SURVEY_DETAIL',
  GET_ASSESSMENT_PDF: 'GET_ASSESSMENT_PDF',
  GET_ASSESSMENT_HISTORY_PDF: 'GET_ASSESSMENT_HISTORY_PDF',
  CHECK_EXPORT_PDF_PERMISSION: 'CHECK_EXPORT_PDF_PERMISSION',

  TEAM: 'TEAM',
  DELETE_MEMBER: 'DELETE_MEMBER',
  SUBSCRIBE: 'SUBSCRIBE',
  GET_PENDING_SUBSCRIPTIONS: 'GET_PENDING_SUBSCRIPTIONS',
  APPROVE_SUBSCRIPTION: 'APPROVE_SUBSCRIPTION',
  DECLINE_SUBSCRIPTION: 'DECLINE_SUBSCRIPTION',
  GET_PAYMENT_HISTORY: 'GET_PAYMENT_HISTORY',
};



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js